// Lightweight global "is a scroll in progress" signal, the web analogue of
// Android passing LazyListState.isScrollInProgress into TaskItem. Scrollable
// containers call notifyScroll() on every scroll event; title belts subscribe
// and pause their marquee while scrolling, resuming shortly after it stops.
let active = false;
let timer = null;
const listeners = new Set();

const emit = () => listeners.forEach((fn) => fn(active));

export const notifyScroll = () => {
  if (!active) {
    active = true;
    emit();
  }
  clearTimeout(timer);
  // Considered "stopped" ~150ms after the last scroll event.
  timer = setTimeout(() => {
    active = false;
    emit();
  }, 150);
};

export const isScrolling = () => active;

export const subscribeScrollActivity = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};
